import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/create")({
  beforeLoad: async ({ context }) => {
    // Org creation only exists on the primary app origin. On an org subdomain
    // there is no sign-up/create — send visitors to that org's sign-in.
    if (context.subdomain) {
      throw redirect({ to: "/sign-in" });
    }
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: CreateLayout,
});

function CreateLayout() {
  return <Outlet />;
}
